var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#15397F"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M950.857143 932.571429V310.857143q0-7.428571-5.428572-12.857143T932.571429 292.571429H310.857143q-7.428571 0-12.857143 5.428571T292.571429 310.857143v621.714286q0 7.428571 5.428571 12.857142t12.857143 5.428572h621.714286q7.428571 0 12.857142-5.428572t5.428572-12.857142z m73.142857-621.714286v621.714286q0 37.714286-26.857143 64.571428t-64.571428 26.857143H310.857143q-37.714286 0-64.571429-26.857143t-26.857143-64.571428V310.857143q0-37.714286 26.857143-64.571429t64.571429-26.857143h621.714286q37.714286 0 64.571428 26.857143t26.857143 64.571429z m-219.428571-219.428572v91.428572h-73.142858V91.428571q0-7.428571-5.428571-12.857142T713.142857 73.142857H91.428571q-7.428571 0-12.857142 5.428572T73.142857 91.428571v621.714286q0 7.428571 5.428572 12.857143t12.857142 5.428571h91.428572v73.142858H91.428571q-37.714286 0-64.571428-26.857143T0 713.142857V91.428571Q0 53.714286 26.857143 26.857143T91.428571 0h621.714286q37.714286 0 64.571429 26.857143t26.857143 64.571428z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/clone-icon.e8967f0520c88d7438b9ed8c154bc201.svg";
export { ForwardRef as ReactComponent };